<template>
    <div class="vgames-container"
      v-touch:swipe.left="swipeHandlerLeft"
      v-touch:swipe.right="swipeHandlerRight">
      <loading-screen
        v-if="!loadingComplete"
        :authComplete="showPage"
        :allGames="allGames" />

      <modal-connection-error v-if="loadingComplete && showConnectionErrorModal"/>

      <div class="swipe-transition-container" v-show="loadingComplete && !showConnectionErrorModal" v-if="authData != null">
        <transition name="fadeSoccer">
          <VFootball v-cloak
            v-if="vsoccerShowing"
            :isDemoMode="isDemoMode"
            :amount="getBalance()"
            :currency="getCurrency()"
            :isShowing="vsoccerShowing"
            :componentsVisible="iphoneVisible"/>
        </transition>
        <transition name="fadeGrayhound">
          <VDogs v-cloak
            :isDemoMode="isDemoMode"
            v-if="vDogShowing"
            :amount="getBalance()"
            :currency="getCurrency()"
            :isShowing="vDogShowing"
            :componentsVisible="iphoneVisible"/>
        </transition>
      </div>
        <!-- multiple conditional children -->

      <games-switcher
        v-if="isGameSwicherVisible()"
        :gameList="allGames"
        :currentGameIndex='currentGameIndex'
        :componentsVisible="iphoneVisible"/>
  </div>
</template>

<script>
import { eventBus } from '@/main.js'
import { store } from '@/store/store.js'
import { storeVDog } from '@/store/storeVDog.js'
import authAPI from '../services/auth/auth.api.service.js'
import EventConstants from '../constants/Events'
import Vue from 'vue'
import VSoccerPage from '@/pages/vsoccer/VSoccerPage.vue'
import GrayhoundRaces from '@/pages/grayhound/GrayHoundPage.vue'
import MobileDevice from '@/mixins/MobileDevice'

export default {
  mixins: [MobileDevice],
  name: 'VGames',
  props: {
    msg: String
  },
  components: {
    'VFootball': VSoccerPage,
    'VDogs': GrayhoundRaces
  },
  methods: {
    getCurrency () {
      return this.storeState.currency
    },
    getBalance () {
      return this.storeState.balance
    },
    getVGamesBody () {
      return document.getElementById('VGamesBody')
    },
    getOffset (el) {
      const rect = el.getBoundingClientRect()
      return {
        left: rect.left + window.scrollX,
        top: rect.top + window.scrollY
      }
    },
    disableSwipeTimeout () {
      this.swipeEnabled = false
      this.swipeTimeLimiter = true
      setTimeout(() => {
        this.swipeEnabled = true
        this.swipeTimeLimiter = false
      })
    },
    swipeHandlerLeft (method) {
      if ((this.swipeEnabled && this.isMobileDevice() && this.allGames.length > 1) || (this.swipeEnabled && method === 'force')) {
        if (this.allGames[0].gameName === 'VFootball') {
          this.vsoccerShowing = false
        } else if (this.allGames[0].gameName === 'VDogs') {
          this.vDogShowing = false
        }
        setTimeout(() => {
          if (this.allGames[0].gameName === 'VFootball') {
            this.vDogShowing = true
          } else if (this.allGames[0].gameName === 'VDogs') {
            this.vsoccerShowing = true
          }
          this.currentGameIndex = 1
          eventBus.onChangeGameAction('true')
        })
        this.disableSwipeTimeout()
      }
    },
    swipeHandlerRight (method) {
      if ((this.swipeEnabled && this.isMobileDevice() && this.allGames.length > 1) || (this.swipeEnabled && method === 'force')) {
        if (this.allGames[0].gameName === 'VFootball') {
          this.vDogShowing = false
        } else if (this.allGames[0].gameName === 'VDogs') {
          this.vsoccerShowing = false
        }

        setTimeout(() => {
          if (this.allGames[0].gameName === 'VFootball') {
            this.vsoccerShowing = true
          } else if (this.allGames[0].gameName === 'VDogs') {
            this.vDogShowing = true
          }
          this.currentGameIndex = 0
          eventBus.onChangeGameAction('true')
        })
        this.disableSwipeTimeout()
      }
    },
    onEventSwipe (data, method) {
      eventBus.showBettingHistoryVDog(false)
      eventBus.showBettingHistory(false)
      eventBus.toggleLeftMenu(false)
      eventBus.toggleLeftMenuVDog(false)
      window.scrollTo(0, 0)
      eventBus.onGameScrollUnock('true')

      if (data === this.currentGameIndex + 1) {
        this.swipeHandlerLeft(method)
      } else if (data === this.currentGameIndex - 1) {
        this.swipeHandlerRight(method)
      }
    },
    onEventFloating (data) {
      if (data) {
        this.swipeEnabled = false
      } else if (!this.swipeTimeLimiter) {
        this.swipeEnabled = true
      }
    },
    getParamsFromUrl () {
      return (new URL(document.location)).searchParams
    },
    onEventLockScroll () {
      document.documentElement.style.overflow = 'hidden'
      this.getVGamesBody().classList.add('lock-scroll')
    },
    onEventUnlockScroll () {
      document.documentElement.style.overflow = 'auto'
      this.getVGamesBody().classList.remove('lock-scroll')
    },
    onLoadingCompleted () {
      this.loadingComplete = true
    },
    showComponents (visible) {
      this.componentsVisible = visible
    },
    isGameSwicherVisible () {
      return this.loadingComplete && this.componentsVisible && this.allGames.length > 1
    }
  },
  computed: {
    iphoneVisible: function () {
      return this.componentsVisible
    }
  },
  created: function () {
    let params = this.getParamsFromUrl()
    if (params.get('lang')) {
      this.$i18n.locale = params.get('lang')
    }

    if (params.get('allowVideo') === 'false') {
      store.setVideoAllowed(false)
      storeVDog.setVideoAllowed(false)
    }
    if (params.get('autoPlayVideo') === 'false') {
      store.setAutoPlay(false)
      storeVDog.setAutoPlay(false)
    }

    if (!params.get('autoPlayVideo')) {
      store.setPauseAllowed(false)
      storeVDog.setPauseAllowed(false)
    }

    if (params.get('allowFullscreen') === 'true') {
      store.setFullscreenAllowed(true)
    }

    authAPI.getAuth(params).subscribe(data => {
      store.setGames(data)
      this.showPage = true
      this.authData = data
      this.allGames = data.games
      if (data.games[0].gameName === 'VFootball') {
        this.vsoccerShowing = true
      } else if (data.games[0].gameName === 'VDogs') {
        this.vDogShowing = true
      }

      this.currentGameIndex = 0

      this.isDemoMode = false
    }, _ => {
      this.showConnectionErrorModal = true
      this.showPage = false
      this.onLoadingCompleted()
    })
    eventBus.$on(EventConstants.VDOG_FLOATING_ACTION, this.onEventFloating)
    eventBus.$on(EventConstants.CHANGE_GAME_ACTION, this.onEventSwipe)
    eventBus.$on(EventConstants.VSOCCER_FLOATING_ACTION, this.onEventFloating)
    eventBus.$on(EventConstants.LOCKING_SCROLL_GLOBAL, this.onEventLockScroll)
    eventBus.$on(EventConstants.UNLOCKING_SCROLL_GLOBAL, this.onEventUnlockScroll)
    eventBus.$on(EventConstants.LOADING_COMPLETE, this.onLoadingCompleted)
    eventBus.$on(EventConstants.COMPONENTS_VISIBLE, this.showComponents)
  },
  beforeDestroy: function () {
    eventBus.$off(EventConstants.VDOG_FLOATING_ACTION, this.onEventFloating)
    eventBus.$off(EventConstants.CHANGE_GAME_ACTION, this.onEventSwipe)
    eventBus.$off(EventConstants.VSOCCER_FLOATING_ACTION, this.onEventFloating)
    eventBus.$off(EventConstants.LOCKING_SCROLL_GLOBAL, this.onEventLockScroll)
    eventBus.$off(EventConstants.UNLOCKING_SCROLL_GLOBAL, this.onEventUnlockScroll)
    eventBus.$off(EventConstants.LOADING_COMPLETE, this.onLoadingCompleted)
    eventBus.$off(EventConstants.COMPONENTS_VISIBLE, this.showComponents)
  },
  data () {
    return {
      showConnectionErrorModal: false,
      swipeEnabled: true,
      showPage: false,
      vsoccerShowing: false,
      isDemoMode: false,
      vDogShowing: false,
      authData: null,
      storeState: store.state,
      allGames: [],
      currentGameIndex: 0,
      pagesComponents: {
        VFootball: Vue.component('vsoccer', VSoccerPage),
        VDogs: Vue.component('grayhound', GrayhoundRaces)
      },
      loadingComplete: false,
      swipeTimeLimiter: false,
      componentsVisible: true
    }
  }
}
</script>
